import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import PropTypes from "prop-types"
import React from "react"
import "./section-card-grid-v2.scss"

const SectionCardGridV2 = ({ callsToAction, gridItems, text, title }) => {
  return (
    <div className="section-card-grid-v2">
      <div className="container">
        <div className="section-card-grid-v2--content">
          <div className="section-card-grid-v2--header">
            {title && <h2 className="section-card-grid-v2--title">{title}</h2>}
            {text?.text && (
              <p className="section-card-grid-v2--text">{text?.text}</p>
            )}
          </div>

          {gridItems && gridItems.length > 0 && (
            <div className="section-card-grid-v2--grid">
              {gridItems.map(gridItem => (
                <div
                  className="section-card-grid-v2--grid-item"
                  key={gridItem.id}
                >
                  {gridItem.linkUrl ? (
                    <a href={gridItem.linkUrl}>
                      <div className="section-card-grid-v2--grid-item-header">
                        <h3 className="section-card-grid-v2--grid-item-title">
                          {gridItem.title}
                        </h3>

                        {gridItem.linkUrl && (
                          <p
                            aria-hidden="true"
                            className="section-card-grid-v2--grid-item-link"
                          >
                            <span>Learn More</span>
                            <svg
                              aria-hidden="true"
                              fill="none"
                              height="25"
                              viewBox="0 0 24 25"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="m12.002 5.244 7 7m0 0-7 7m7-7h-14"
                                stroke="#122f4e"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.995"
                              />
                            </svg>
                          </p>
                        )}
                      </div>
                      <p className="section-card-grid-v2--grid-item-text">
                        {gridItem.text?.text}
                      </p>
                    </a>
                  ) : (
                    <>
                      <div className="section-card-grid-v2--grid-item-header">
                        <h3 className="section-card-grid-v2--grid-item-title">
                          {gridItem.title}
                        </h3>
                      </div>
                      <p className="section-card-grid-v2--grid-item-text">
                        {gridItem.text?.text}
                      </p>
                    </>
                  )}
                </div>
              ))}
            </div>
          )}

          {callsToAction && callsToAction.length > 0 && (
            <div className="section-card-grid-v2--calls-to-action">
              {callsToAction &&
                callsToAction.map(callToAction => (
                  <ButtonV2
                    accessibilityLabel={callToAction.accessibilityLabel}
                    className={getButtonClasses(
                      callToAction.buttonStyle,
                      callToAction.buttonSize
                    )}
                    href={callToAction.path}
                    key={callToAction.id}
                    showArrow={callToAction.showArrow === "Yes" ? true : false}
                    text={callToAction.text}
                  />
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SectionCardGridV2

SectionCardGridV2.propTypes = {
  callsToAction: PropTypes.array.isRequired,
  gridItems: PropTypes.array.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}
